import { useEffect } from 'react'
import { useSelectionStore } from '@editorStores'

/**
 * Clears the scene selection when a scoped tool/step panel is entered and again when it is left,
 * so a step always starts and ends clean (guided IFC steps, draw panels).
 *
 * This is the **only** sanctioned way to tie the selection's lifetime to a component. Page-level,
 * scene and drawer code must never clear the selection on unmount: it deliberately survives page,
 * floorplan/3D and mode switches, and what a transition keeps is decided centrally by
 * `selectionStore/reconcile.ts` (a local cleanup silently overrides that policy — it is what made
 * an IFC-page planar selection vanish on the way to Structural Planning). The
 * `no-restricted-syntax` rule in `eslint.config.mjs` enforces this; use this hook instead.
 */
const useScopedSelectionReset = (): void => {
  const clearSelection = useSelectionStore(state => state.clearSelection)

  useEffect(() => {
    clearSelection()

    return () => clearSelection()
  }, [clearSelection])
}

export default useScopedSelectionReset
